import React from 'react';

export default function SVGHeartKeyhole(): JSX.Element {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      className="text-iconStrong stroke-iconStrong fill-iconStrong"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clip-rule="evenodd"
        d="m23.2899 5.08041c-.4689-.91485-1.1461-1.70689-1.9769-2.3124s-1.7921-1.00759-2.8067-1.17392c-1.0145-.16633-2.0539-.09226-3.0345.21625-.9807.30852-1.8753.84286-2.6119 1.56007l-.52.47c-.0924.08575-.2139.1334-.34.1334s-.2475-.04765-.34-.1334l-.49-.45c-.7317-.73241-1.62868-1.27824-2.61544-1.5915-.98675-.31325-2.03435-.38476-3.05452-.2085-1.01871.15805-1.9849.55723-2.8181 1.1643s-1.50927 1.40444-1.9719 2.3257c-.6162976 1.21089-.831237 2.5865-.6137001 3.92767.2175361 1.34122.8562591 2.57832 1.8237001 3.53232l9.35996 9.66c.0933.0968.2052.1738.3289.2264.1237.0525.2567.0796.3911.0796.1345 0 .2675-.0271.3912-.0796.1237-.0526.2356-.1296.3288-.2264l9.34-9.64c.9724-.9548 1.6157-2.1943 1.8369-3.53907.2211-1.34475.0086-2.72498-.6069-3.94092zm-11.2922 2.27359c1.2439 0 2.2522 1.00828 2.2522 2.25214 0 .73156-.3494 1.38056-.8899 1.79166-.1817.1382-.2913.3627-.2399.5851l.6056 2.6188c.0724.3134-.1655.6127-.4872.6127h-2.4815c-.3217 0-.5596-.2993-.4872-.6127l.6056-2.6188c.0515-.2224-.0582-.4469-.2399-.5851-.5405-.4111-.88989-1.0601-.88989-1.79166 0-1.24388 1.00839-2.25214 2.25209-2.25214z"
        fill="#a5b4fc"
        fill-rule="evenodd"
      />
    </svg>
  );
}
